module.exports = __webpack_public_path__ + "img/marker-oil-transport-green.a5ac4075.png";